import { useCallback } from "react";
import { EwayBillCancelReturn, EwayBillDeleteReturn } from "@/services/api/ewaybill";
import OrderDTO from "@/dto/order/OrderDTO";
import _ from "lodash";
import { useOrderManagementStore } from "../store/OrderManagementStore";

export function getUpdatedEwaybillNewOrder(order: OrderDTO, result: EwayBillCancelReturn | EwayBillDeleteReturn) {
    // @ts-ignore
    const ewaybillIds = result.canceledEwaybillIds ? result.canceledEwaybillIds : result.deletedEwaybillIds;
    const { newHasEwaybillNo, newLogisticsCompany, newWaybillNo } = result;
    const newOrder = _.cloneDeep(order);

    ewaybillIds.forEach((cancelId) => {
        newOrder.ewaybills = newOrder.ewaybills?.filter(({ id }) => {
            return id !== cancelId;
        });
    });

    newOrder.hasEwaybillNo = newHasEwaybillNo;
    newOrder.logisticsCompany = newLogisticsCompany;
    newOrder.waybillNo = newWaybillNo;

    return newOrder;
}

const useUpdateOrderEwaybill = () => {
    const orderManagementStore = useOrderManagementStore();

    const handleUpdateOrder = useCallback((order: OrderDTO, result: EwayBillCancelReturn | EwayBillDeleteReturn) => {
        const newOrder = getUpdatedEwaybillNewOrder(order, result);

        orderManagementStore?.table?.updateOrder(order.id, newOrder);

        return newOrder;
    }, []);

    return { handleUpdateOrder };
};

export default useUpdateOrderEwaybill;
